// src/components/Admin/SalasCmp/SalasItem_Salas.jsx
import React, { useState } from "react";
import { Icon } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import { MozillaHubRoomsApi } from "../../../../api";
import { useAuth } from "../../../../hooks";
import "./SalasItem_Salas.scss";

const CIRCLE_COLOR_MAP = {
  "CIENCIAS HUMANAS": "circle--ciencias-humanas",
  "CIENCIAS NATURALES": "circle--ciencias-naturales",
  HISTORIA: "circle--historia",
  MATEMATICAS: "circle--matematicas",
  ARTE: "circle--arte",
  "VIDA SALUDABLE": "circle--vida-saludable",
  OTROS: "circle--gray",
};

const mozillaHubRoomsApi = new MozillaHubRoomsApi();

export function SalasItemSalas({ scene, onUploadScene }) {
  const navigate = useNavigate();
  const { accessToken } = useAuth();
  const [loadingScene, setLoadingScene] = useState(false);
  const [errorScene, setErrorScene] = useState(null);

  const normalizeCategory = (cat) =>
    cat.trim().toUpperCase()
      .replace(/Á/g, "A")
      .replace(/É/g, "E")
      .replace(/Í/g, "I")
      .replace(/Ó/g, "O")
      .replace(/Ú/g, "U");

  const getCircleColorClass = (cat) =>
    CIRCLE_COLOR_MAP[normalizeCategory(cat)] || "circle--gray";

  const handleInfoClick = () => {
    navigate(`/teacher/guia/${scene.refId}`);
  };

  const handleUploadClick = () => {
    onUploadScene?.(scene);
  };

  const handleEnterClick = async () => {
  try {
    setLoadingScene(true);
    setErrorScene(null);

    const url = scene.urlsala;
    // 1) Comprobamos si es una escena de Mozilla Hub
    const isHub = url.startsWith("https://educa360.org/scenes/");

    if (isHub) {
      // 2) Extraemos el shortLink
      const cleaned = url.replace(/\/+$/, "");
      const shortLink = cleaned.split("/").pop();

      // 3) Llamada a LoadRoom
      const result = await mozillaHubRoomsApi.LoadRoom(
        accessToken,
        shortLink
      );

      // 4) Montamos la URL embed y la abrimos
      const { id, embedToken } = result.room;
      const finalUrl = `https://educa360.org/${id}?embed_token=${embedToken}`;
      window.open(finalUrl, "_blank", "noopener,noreferrer");
    } else {
      // No es Hub: abrimos directamente la URL que trae scene.urlsala
      window.open(url, "_blank", "noopener,noreferrer");
    }
  } catch (err) {
    console.error("Error cargando la sala:", err);
    setErrorScene(err.message || "Error desconocido");
  } finally {
    setLoadingScene(false);
  }
};


  return (
    <div className="ui-materials">
      <div className="e-card-scene">
        {loadingScene && (
          <div className="loading-overlay">Cargando sala…</div>
        )}
        <img
          className="card-banner"
          src={scene.bannertopUrl}
          alt={scene.title}
        />
        <div className="card-body">
          {errorScene && (
            <p className="error-text">¡{errorScene}!</p>
          )}
          <p className="card-createdby">Creado por: Educa360</p>
          <div className="card-circles">
            {scene.category?.map((cat) => (
              <div
                key={cat}
                className={`circle ${getCircleColorClass(cat)}`}
              />
            ))}
            {scene.subcategory && (
              <h4 className="card-subcategorie">
                {scene.subcategory.join(", ")}
              </h4>
            )}
          </div>
          <h3 className="card-title">{scene.title}</h3>
          <hr className="card-divider" />
          <div className="card-actions">
            <div className="tooltip-container">
              <button
                className="btn-icon"
                onClick={handleEnterClick}
                disabled={loadingScene}
              >
                <Icon name="eye" />
              </button>
              <span className="tooltip-text">Entrar en escena</span>
            </div>
            <div className="tooltip-container">
              <button className="btn-icon" onClick={handleInfoClick}>
                <Icon name="list" />
              </button>
              <span className="tooltip-text">Ver Unidad Didáctica</span>
            </div>
            <div className="tooltip-container">
              <button className="btn-add-route" onClick={handleUploadClick}>
                <Icon className="btn-add-route__ico" name="sign-in" />
              </button>
              <span className="tooltip-text">Añadir a Itinerario</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
